import { createContext } from 'react'

export type UiThemeMode = 'light' | 'dark'

export interface UiThemeContextValue {
    mode: UiThemeMode
    toggleMode: () => void
}

export const UiThemeContext = createContext<UiThemeContextValue | undefined>(undefined)
